<p-table #dt  styleClass="p-datatable-sm p-datatable-gridlines" 
    [columns]="columns" [value]="items.controls" [rowHover]="true" responsiveLayout="scroll"
    [customSort]="true" (sortFunction)="customSort($event)"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [totalRecords]="totalRecords" 
    [rows]="10" [paginator]="paginator" [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
            <h5 *ngIf="title">{{ title }}</h5>
            <p-badge *ngIf="mostrarIdx" size="" value="{{ nombre }}: {{items.controls.length}}"></p-badge>
            <span class="mt-2 md:mt-0 p-input-icon-left" *ngIf="filtrar">
                <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="filterText" (keydown.enter)="filterData($event.target)"
                (focusout)="filterData($event.target, true)" placeholder="Buscar..." />
            </span>
            <button *ngIf="crud && (esNuevo || editando)" pButton pRipple type="button" class="p-button-rounded p-button-success mr-2" icon="pi pi-plus" 
                (click)="btnNew()" pTooltip="Nuevo" label="Nuevo">
            </button>
        </div>
        
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th *ngIf="isModulo" class="align-center cabecera">Acciones</th>
            <ng-container *ngFor="let col of columns">
                <th class="align-center cabecera"  [pSortableColumn]="col.field">{{ col.label }}<p-sortIcon [field]="col.field"></p-sortIcon></th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
        <tr *ngIf="filter(item.value)" (click)="onClick(item)">
            <td *ngIf="isModulo" style="max-width: 5rem" class="align-center">
                <button pButton pRipple type="button" class="p-button-rounded p-button-success mr-2" icon="pi pi-check" 
                    style="width: 2.1rem; height: 2rem;" (click)="btnSelect(item.value)" pTooltip="Seleccionar">
                </button>
                <button pButton pRipple type="button" class="p-button-rounded" icon="pi pi-pencil" 
                    style="width: 2.1rem; height: 2rem;" (click)="onClick(item, true)" pTool    ip="Editar">
                </button>
            </td>
            <ng-container *ngFor="let col of columns">
                <ng-container>
                    <td *ngIf="col.type === 'id'" style="width:8%; min-width:8rem;">
                        {{ item.get(col.field).value }}
                    </td>
                    <td *ngIf="col.type === 'text'">
                        {{ item.get(col.field).value }}
                    </td>
                    <td class="align-monto" *ngIf="col.type === 'number'">
                        {{ item.get(col.field).value | currency: '': '': '0.0-0': 'es-PY' }}
                    </td>
                    <ng-container *ngIf="col.type === 'boolean'">
                        <td *ngIf="item.get(col.field).value === true" class="align-center">
                            <i class="pi pi-check-circle" style="color: green; font-size: 1.5rem;"></i>
                        </td>
                        <td *ngIf="item.get(col.field).value === false" class="align-center">
                            <i class="pi pi-times-circle" style="color: red; font-size: 1.5rem;"></i>
                        </td>
                    </ng-container>
                    <td *ngIf="col.type === 'date'">
                        {{ item.get(col.field).value | date: 'dd/MM/yyyy' }}
                    </td>
                    <td *ngIf="col.type === 'datetime'">
                        {{ item.get(col.field).value | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </td>
                    <td *ngIf="col.type === 'multiselect'" class="align-center">
                        <span [class]="'custom-badge status-qualified'">{{ getOptionLabel(col.options, item.get(col.field).value ) }}</span>
                    </td>
                </ng-container>
            </ng-container>
            <!-- <td *ngIf="crud && (esNuevo || editando)" style="max-width: 4rem;"></td> -->
        </tr>
    </ng-template>
</p-table>